export class PayloadSanitizerUtil {
  private static biomeMap(input?: string | null): string | null {
    if (!input) return null;
    const s = String(input).trim().toUpperCase();
    const norm = s
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_');
    const map: Record<string, string> = {
      'AMAZONIA': 'AMAZONIA',
      'CAATINGA': 'CAATINGA',
      'CERRADO': 'CERRADO',
      'PANTANAL': 'PANTANAL',
      'PAMPA': 'PAMPA',
      'MATA_ATLANTICA': 'MATA_ATRANTICA',
      'MATA_ATRANTICA': 'MATA_ATRANTICA'
    };
    return map[norm] ?? input;
  }

  static normalizeUrl(input?: string | null, requireHttps: boolean = true): string | null {
    if (input == null) return input as any;
    let s = String(input).trim();
    if (!s) return s;
    s = s.replace(/&amp;/g, '&');
    if (!/^https?:\/\//i.test(s)) s = (requireHttps ? 'https://' : 'http://') + s;
    try {
      const u = new URL(s);
      const params = new URLSearchParams(u.search);
      u.search = params.toString();
      return u.toString();
    } catch {
      return s;
    }
  }

  private static onlyDigits(input?: string | null): string | null {
    if (input == null) return input as any;
    const r = String(input).replace(/[^A-Za-z0-9]+/g, '');
    return r || null;
  }

  private static toStringOrNull(input?: any): string | null {
    if (input === null || input === undefined) return null;
    const s = String(input).trim();
    return s || null;
  }

  static sanitize(form: any, requireHttps: boolean = true) {
    const out = { ...(form || {}) };

    if (out.onlineStatementLink !== undefined) {
      out.onlineStatementLink = this.normalizeUrl(out.onlineStatementLink, requireHttps);
    }
    if (out.ramComplianceReportLink !== undefined) {
      out.ramComplianceReportLink = this.normalizeUrl(out.ramComplianceReportLink, requireHttps);
    }
    if (out.methodologyReportLink !== undefined) {
      out.methodologyReportLink = this.normalizeUrl(out.methodologyReportLink, requireHttps);
    }

    if (Array.isArray(out.locations)) {
      out.locations = out.locations.map((l: any) => {
        const loc = { ...(l || {}) };

        if (loc.registrationRecordLink !== undefined) {
          loc.registrationRecordLink = this.normalizeUrl(loc.registrationRecordLink, requireHttps);
        }

        if (loc.latitude !== undefined || loc.lat !== undefined) {
          const v = loc.latitude ?? loc.lat;
          loc.latitude = this.toStringOrNull(v);
        }
        if (loc.longitude !== undefined || loc.long !== undefined) {
          const v = loc.longitude ?? loc.long;
          loc.longitude = this.toStringOrNull(v);
        }

        if (loc.biome !== undefined) {
          loc.biome = this.biomeMap(loc.biome);
        }

        if (loc.landOwnerCpfCnpj !== undefined) {
          loc.landOwnerCpfCnpj = this.onlyDigits(loc.landOwnerCpfCnpj);
        }

        if (loc.country !== undefined) loc.country = this.toStringOrNull(loc.country);
        if (loc.state !== undefined) loc.state = this.toStringOrNull(loc.state);
        if (loc.municipality !== undefined) loc.municipality = this.toStringOrNull(loc.municipality);
        if (loc.registrationRecord !== undefined) loc.registrationRecord = this.toStringOrNull(loc.registrationRecord);

        return loc;
      });
    }

    return out;
  }
}